var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-swiper-bar__wrapper" }, [
    _c("span", {
      staticClass: "rb-swiper-bar__element",
      style: {
        width: _vm.width + "%",
        left: _vm.translateX + "%",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }